import { createSlice } from "@reduxjs/toolkit";

const tasksStatusesSlice = createSlice({
  name: "tasksStatuses",
  initialState: {},
  reducers: {
    setTasksStatusesData: (_state, action) => action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setTasksStatusesData } = tasksStatusesSlice.actions;

export const tasksStatuses = tasksStatusesSlice.reducer;

export default tasksStatusesSlice.reducer;
